export enum MyAccountTab {
    ResponsibleGaming = 1,
    ChangePassword = 2,
    Bonuses = 3,
    PersonalDetails = 4,
    InviteAFriend = 5,
    Reports = 6,
    LCChallenges = 7, //LC I think it comes from something with Loyalty
    LCRedemption = 8,
    Tournament = 10,
    FreePlay = 11,
    FreeBets = 12,
    ComPoints = 13,
    MyChallenges = 16
}

export interface IOpenMyAccountOptions {
    tabId?: MyAccountTab;
}
export interface IMyAccountExternalLinkHandler {
    openMyAccount(options?: IOpenMyAccountOptions): Promise<void>;
}